module.exports = __webpack_public_path__ + "static/media/canverse-morrow.f90436ae.png";